<template>
  <div class="invoice-wrapper">
    <iframe
      v-if="iframeUrl"
      :src="iframeUrl"
      frameborder="0"
      class="invoice-iframe"
    />
  </div>
</template>

<script>
export default {
  name: "PaymentInvoice",

  data() {
    return {
      iframeUrl: null,
    };
  },
  created() {
    const token = this.$route.params.token;

    if (token) {
      this.iframeUrl = `https://pv3.gkh-center.ru/#/payment-invoice/${token}`;
    } else {
      console.error("Токен не передан");
    }
  },
};
</script>

<style>
.invoice-wrapper {
  width: 100%;
  height: 100vh;
}

.invoice-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
